import React, { useState, useCallback } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 orange:'#E05A00', orangeBg:'#FEF0E6',
 dark:'#0F1E14',
};
const inr = n => '₹'+Number(Math.round(n)||0).toLocaleString('en-IN');

// ── FULL MENU DATA ─────────────────────────────────────────────────────────────
export const MENU_DATA = {
 'Breakfast': {
 color: C.amber,
 categories: {
 'Hot Items': [
 {id:'b1', name:'Poha', veg:true, price:80, unit:'per plate', description:'Flattened rice with veggies & peanuts'},
 {id:'b2', name:'Upma', veg:true, price:80, unit:'per plate', description:'Semolina with vegetables'},
 {id:'b3', name:'Idli Sambhar (4 pcs)', veg:true, price:100, unit:'per plate', description:'Steamed rice cakes with sambhar & chutney'},
 {id:'b4', name:'Medu Vada (2 pcs)', veg:true, price:90, unit:'per plate', description:'Crispy lentil donuts'},
 {id:'b5', name:'Masala Dosa', veg:true, price:120, unit:'per plate', description:'Crispy dosa with potato filling'},
 {id:'b6', name:'Aloo Paratha', veg:true, price:110, unit:'per plate', description:'Stuffed potato flatbread with butter & curd'},
 {id:'b7', name:'Puri Bhaji', veg:true, price:100, unit:'per plate', description:'Fried bread with potato curry'},
 {id:'b8', name:'Chole Bhature', veg:true, price:130, unit:'per plate', description:'Spiced chickpeas with fried bread'},
 ],
 'Continental': [
 {id:'b9', name:'Bread Toast with Butter & Jam', veg:true, price:60, unit:'per plate'},
 {id:'b10', name:'Boiled Eggs (2 pcs)', veg:false, price:60, unit:'per plate'},
 {id:'b11', name:'Omelette (2 eggs)', veg:false, price:90, unit:'per plate', description:'Plain / Masala / Cheese'},
 {id:'b12', name:'Cornflakes with Milk', veg:true, price:80, unit:'per bowl'},
 {id:'b13', name:'Fresh Fruit Plate', veg:true, price:120, unit:'per plate'},
 ],
 'Beverages': [
 {id:'b14', name:'Tea', veg:true, price:30, unit:'per cup'},
 {id:'b15', name:'Coffee', veg:true, price:40, unit:'per cup'},
 {id:'b16', name:'Fresh Lime Water', veg:true, price:40, unit:'per glass'},
 {id:'b17', name:'Lassi (Sweet/Salted)', veg:true, price:60, unit:'per glass'},
 {id:'b18', name:'Fresh Fruit Juice', veg:true, price:80, unit:'per glass'},
 ],
 }
 },
 'Lunch': {
 color: C.accent,
 categories: {
 'Indian Veg': [
 {id:'l1', name:'Dal Makhani', veg:true, price:160, unit:'per portion', description:'Creamy black lentils'},
 {id:'l2', name:'Dal Tadka', veg:true, price:140, unit:'per portion'},
 {id:'l3', name:'Paneer Butter Masala', veg:true, price:220, unit:'per portion'},
 {id:'l4', name:'Shahi Paneer', veg:true, price:240, unit:'per portion'},
 {id:'l5', name:'Palak Paneer', veg:true, price:200, unit:'per portion'},
 {id:'l6', name:'Matar Paneer', veg:true, price:200, unit:'per portion'},
 {id:'l7', name:'Aloo Gobi', veg:true, price:150, unit:'per portion'},
 {id:'l8', name:'Mix Veg', veg:true, price:160, unit:'per portion'},
 {id:'l9', name:'Rajma Masala', veg:true, price:160, unit:'per portion'},
 {id:'l10', name:'Chana Masala', veg:true, price:160, unit:'per portion'},
 {id:'l11', name:'Baingan Bharta', veg:true, price:160, unit:'per portion'},
 {id:'l12', name:'Kadai Paneer', veg:true, price:230, unit:'per portion'},
 ],
 'Indian Non-Veg': [
 {id:'l13', name:'Butter Chicken', veg:false, price:280, unit:'per portion'},
 {id:'l14', name:'Chicken Curry', veg:false, price:260, unit:'per portion'},
 {id:'l15', name:'Chicken Kadai', veg:false, price:270, unit:'per portion'},
 {id:'l16', name:'Mutton Curry', veg:false, price:350, unit:'per portion'},
 {id:'l17', name:'Mutton Rogan Josh', veg:false, price:380, unit:'per portion'},
 {id:'l18', name:'Fish Curry', veg:false, price:300, unit:'per portion'},
 {id:'l19', name:'Egg Curry', veg:false, price:180, unit:'per portion'},
 {id:'l20', name:'Keema Matar', veg:false, price:280, unit:'per portion'},
 ],
 'Breads': [
 {id:'l21', name:'Tandoori Roti', veg:true, price:20, unit:'per piece'},
 {id:'l22', name:'Butter Roti', veg:true, price:25, unit:'per piece'},
 {id:'l23', name:'Naan', veg:true, price:40, unit:'per piece'},
 {id:'l24', name:'Butter Naan', veg:true, price:50, unit:'per piece'},
 {id:'l25', name:'Garlic Naan', veg:true, price:60, unit:'per piece'},
 {id:'l26', name:'Paratha', veg:true, price:50, unit:'per piece'},
 {id:'l27', name:'Puri (4 pcs)', veg:true, price:60, unit:'per plate'},
 ],
 'Rice & Biryani': [
 {id:'l28', name:'Steamed Rice', veg:true, price:80, unit:'per portion'},
 {id:'l29', name:'Jeera Rice', veg:true, price:100, unit:'per portion'},
 {id:'l30', name:'Veg Biryani', veg:true, price:180, unit:'per portion'},
 {id:'l31', name:'Chicken Biryani', veg:false, price:280, unit:'per portion'},
 {id:'l32', name:'Mutton Biryani', veg:false, price:350, unit:'per portion'},
 {id:'l33', name:'Egg Biryani', veg:false, price:200, unit:'per portion'},
 {id:'l34', name:'Veg Pulao', veg:true, price:140, unit:'per portion'},
 ],
 'Chinese': [
 {id:'l35', name:'Veg Fried Rice', veg:true, price:160, unit:'per portion'},
 {id:'l36', name:'Egg Fried Rice', veg:false, price:180, unit:'per portion'},
 {id:'l37', name:'Chicken Fried Rice', veg:false, price:220, unit:'per portion'},
 {id:'l38', name:'Veg Noodles', veg:true, price:160, unit:'per portion'},
 {id:'l39', name:'Chicken Noodles', veg:false, price:220, unit:'per portion'},
 {id:'l40', name:'Veg Manchurian (Dry)', veg:true, price:180, unit:'per portion'},
 {id:'l41', name:'Veg Manchurian (Gravy)', veg:true, price:190, unit:'per portion'},
 {id:'l42', name:'Chicken Manchurian', veg:false, price:260, unit:'per portion'},
 {id:'l43', name:'Chilli Paneer (Dry)', veg:true, price:220, unit:'per portion'},
 {id:'l44', name:'Chilli Chicken (Dry)', veg:false, price:260, unit:'per portion'},
 {id:'l45', name:'Veg Spring Rolls (4 pcs)', veg:true, price:160, unit:'per plate'},
 {id:'l46', name:'Chicken Spring Rolls (4 pcs)', veg:false, price:200, unit:'per plate'},
 {id:'l47', name:'Veg Soup', veg:true, price:100, unit:'per bowl'},
 {id:'l48', name:'Chicken Soup', veg:false, price:140, unit:'per bowl'},
 ],
 'Salads & Raita': [
 {id:'l49', name:'Green Salad', veg:true, price:80, unit:'per portion'},
 {id:'l50', name:'Raita (Boondi/Veg)', veg:true, price:80, unit:'per portion'},
 {id:'l51', name:'Papad', veg:true, price:30, unit:'per piece'},
 {id:'l52', name:'Pickle', veg:true, price:20, unit:'per portion'},
 ],
 'Desserts': [
 {id:'l53', name:'Gulab Jamun (2 pcs)', veg:true, price:80, unit:'per plate'},
 {id:'l54', name:'Rasgulla (2 pcs)', veg:true, price:80, unit:'per plate'},
 {id:'l55', name:'Kheer', veg:true, price:100, unit:'per bowl'},
 {id:'l56', name:'Ice Cream (2 scoops)', veg:true, price:100, unit:'per serving'},
 {id:'l57', name:'Halwa', veg:true, price:90, unit:'per portion'},
 {id:'l58', name:'Gajar Halwa', veg:true, price:100, unit:'per portion'},
 ],
 }
 },
 'Hi-Tea / Snacks': {
 color: C.purple,
 categories: {
 'Starters — Veg': [
 {id:'h1', name:'Samosa (2 pcs)', veg:true, price:60, unit:'per plate'},
 {id:'h2', name:'Veg Pakora', veg:true, price:120, unit:'per plate'},
 {id:'h3', name:'Paneer Tikka', veg:true, price:220, unit:'per plate'},
 {id:'h4', name:'Hara Bhara Kebab (4 pcs)', veg:true, price:180, unit:'per plate'},
 {id:'h5', name:'Dahi Ke Sholey (4 pcs)', veg:true, price:200, unit:'per plate'},
 {id:'h6', name:'Veg Seekh Kebab (4 pcs)', veg:true, price:200, unit:'per plate'},
 {id:'h7', name:'Corn Tikki (4 pcs)', veg:true, price:160, unit:'per plate'},
 {id:'h8', name:'Pav Bhaji', veg:true, price:140, unit:'per plate'},
 {id:'h9', name:'Aloo Tikki (4 pcs)', veg:true, price:120, unit:'per plate'},
 {id:'h10', name:'Dhokla', veg:true, price:100, unit:'per plate'},
 ],
 'Starters — Non Veg': [
 {id:'h11', name:'Chicken Tikka (6 pcs)', veg:false, price:280, unit:'per plate'},
 {id:'h12', name:'Seekh Kebab (4 pcs)', veg:false, price:280, unit:'per plate'},
 {id:'h13', name:'Chicken Wings (6 pcs)', veg:false, price:260, unit:'per plate'},
 {id:'h14', name:'Fish Tikka (4 pcs)', veg:false, price:300, unit:'per plate'},
 {id:'h15', name:'Mutton Seekh Kebab (4 pcs)', veg:false, price:320, unit:'per plate'},
 {id:'h16', name:'Tandoori Chicken (half)', veg:false, price:350, unit:'per portion'},
 ],
 'Beverages': [
 {id:'h17', name:'Tea', veg:true, price:30, unit:'per cup'},
 {id:'h18', name:'Coffee', veg:true, price:40, unit:'per cup'},
 {id:'h19', name:'Cold Coffee', veg:true, price:80, unit:'per glass'},
 {id:'h20', name:'Lassi', veg:true, price:60, unit:'per glass'},
 {id:'h21', name:'Lemonade', veg:true, price:50, unit:'per glass'},
 {id:'h22', name:'Shikanji', veg:true, price:50, unit:'per glass'},
 {id:'h23', name:'Soft Drinks', veg:true, price:40, unit:'per bottle'},
 {id:'h24', name:'Buttermilk (Chaas)', veg:true, price:40, unit:'per glass'},
 ],
 }
 },
 'Dinner': {
 color: C.blue,
 categories: {
 'Indian Veg': [
 {id:'d1', name:'Dal Makhani', veg:true, price:160, unit:'per portion'},
 {id:'d2', name:'Paneer Butter Masala', veg:true, price:220, unit:'per portion'},
 {id:'d3', name:'Shahi Paneer', veg:true, price:240, unit:'per portion'},
 {id:'d4', name:'Kadai Paneer', veg:true, price:230, unit:'per portion'},
 {id:'d5', name:'Mix Veg', veg:true, price:160, unit:'per portion'},
 {id:'d6', name:'Aloo Matar', veg:true, price:150, unit:'per portion'},
 {id:'d7', name:'Rajma Chawal', veg:true, price:180, unit:'per portion'},
 ],
 'Indian Non-Veg': [
 {id:'d8', name:'Butter Chicken', veg:false, price:280, unit:'per portion'},
 {id:'d9', name:'Chicken Curry', veg:false, price:260, unit:'per portion'},
 {id:'d10', name:'Mutton Rogan Josh', veg:false, price:380, unit:'per portion'},
 {id:'d11', name:'Fish Masala', veg:false, price:300, unit:'per portion'},
 {id:'d12', name:'Egg Bhurji', veg:false, price:160, unit:'per portion'},
 ],
 'Breads & Rice': [
 {id:'d13', name:'Tandoori Roti', veg:true, price:20, unit:'per piece'},
 {id:'d14', name:'Butter Naan', veg:true, price:50, unit:'per piece'},
 {id:'d15', name:'Garlic Naan', veg:true, price:60, unit:'per piece'},
 {id:'d16', name:'Steamed Rice', veg:true, price:80, unit:'per portion'},
 {id:'d17', name:'Jeera Rice', veg:true, price:100, unit:'per portion'},
 {id:'d18', name:'Veg Biryani', veg:true, price:180, unit:'per portion'},
 {id:'d19', name:'Chicken Biryani', veg:false, price:280, unit:'per portion'},
 ],
 'Chinese': [
 {id:'d20', name:'Veg Fried Rice', veg:true, price:160, unit:'per portion'},
 {id:'d21', name:'Chicken Fried Rice', veg:false, price:220, unit:'per portion'},
 {id:'d22', name:'Veg Noodles', veg:true, price:160, unit:'per portion'},
 {id:'d23', name:'Veg Manchurian', veg:true, price:190, unit:'per portion'},
 {id:'d24', name:'Chilli Chicken', veg:false, price:260, unit:'per portion'},
 ],
 'Desserts & Beverages': [
 {id:'d25', name:'Gulab Jamun (2 pcs)', veg:true, price:80, unit:'per plate'},
 {id:'d26', name:'Kheer', veg:true, price:100, unit:'per bowl'},
 {id:'d27', name:'Ice Cream', veg:true, price:100, unit:'per serving'},
 {id:'d28', name:'Tea / Coffee', veg:true, price:35, unit:'per cup'},
 ],
 }
 },
};

// ── PACKAGE PRESETS ───────────────────────────────────────────────────────────
export const PACKAGE_PRESETS = [
 {
 name: 'Corporate Day Out — Veg',
 pax: 100,
 meals: ['Breakfast', 'Lunch', 'Hi-Tea / Snacks'],
 items: ['b1','b3','b14','l1','l3','l21','l23','l28','l30','l35','l49','l50','l53','h1','h3','h17','h18'],
 },
 {
 name: 'Corporate Day Out — Non Veg',
 pax: 100,
 meals: ['Breakfast', 'Lunch', 'Hi-Tea / Snacks'],
 items: ['b1','b3','b10','b14','l1','l13','l21','l23','l28','l31','l35','l44','l49','l50','l53','h11','h12','h17','h18'],
 },
 {
 name: 'School Picnic — Veg',
 pax: 150,
 meals: ['Lunch', 'Hi-Tea / Snacks'],
 items: ['l1','l3','l21','l28','l30','l35','l49','l53','h1','h2','h17','h18'],
 },
 {
 name: 'Wedding Package — Full Day',
 pax: 300,
 meals: ['Breakfast', 'Lunch', 'Hi-Tea / Snacks', 'Dinner'],
 items: ['b1','b3','b5','b14','l1','l3','l12','l13','l14','l21','l23','l25','l28','l31','l32','l35','l43','l44','l49','l50','l53','l54','l56','h1','h3','h11','h12','h15','h17','h18','d1','d2','d8','d9','d13','d15','d17','d19','d25','d26'],
 },
];


// ── ATOMS ─────────────────────────────────────────────────────────────────────
const Card = ({children,style={}}) => <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.05)',...style}}>{children}</div>;
const SH = ({title,icon,color,bg,right}) => (
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'13px 18px',borderBottom:`1px solid ${C.border}`,background:bg||'#F5F8F5',borderRadius:'12px 12px 0 0'}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}><span style={{fontSize:18}}>{icon}</span><span style={{fontSize:14,fontWeight:700,color:color||C.text}}>{title}</span></div>
 {right}
 </div>
);
const Btn = ({children,onClick,variant='primary',style={},disabled}) => {
 const v={primary:{background:C.accent,color:'#fff',border:'none'},ghost:{background:'transparent',color:C.text2,border:`1px solid ${C.border2}`},outline:{background:'transparent',color:C.accent,border:`1px solid ${C.accent}`},amber:{background:C.amberBg,color:C.amber,border:`1px solid ${C.amberBorder}`},red:{background:C.redBg,color:C.red,border:`1px solid ${C.redBorder}`}};
 return <button onClick={onClick} disabled={disabled} style={{...v[variant]||v.primary,padding:'8px 16px',borderRadius:8,fontSize:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',opacity:disabled?.5:1,display:'inline-flex',alignItems:'center',gap:6,whiteSpace:'nowrap',...style}}>{children}</button>;
};
const VegBadge = ({veg}) => (
 <span style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:16,height:16,border:`1.5px solid ${veg?C.accent:C.red}`,borderRadius:3,flexShrink:0}}>
 <span style={{width:8,height:8,borderRadius:'50%',background:veg?C.accent:C.red}}/>
 </span>
);

// ── FOOD MENU SELECTOR (used by Sales) ───────────────────────────────────────
export function FoodMenuSelector({booking, pax=100, onSave, onClose}) {
 const [activeMeal, setActiveMeal] = useState('Lunch');
 const [selected, setSelected] = useState({}); // {itemId: {item, qty, meal, instructions}}
 const [search, setSearch] = useState('');
 const [filterVeg, setFilterVeg] = useState('All'); // All, Veg, NonVeg
 const [instructions, setInstructions] = useState('');
 const [activePreset, setActivePreset] = useState(null);
 const [paxCount, setPaxCount] = useState(pax);

 // Apply preset
 const applyPreset = (preset) => {
 const newSelected = {};
 preset.items.forEach(id => {
 Object.values(MENU_DATA).forEach(meal => {
 Object.values(meal.categories).forEach(items => {
 const item = items.find(i => i.id === id);
 if(item) newSelected[id] = {item, qty: paxCount, meal: activeMeal, instructions:''};
 });
 });
 });
 setSelected(newSelected);
 setActivePreset(preset.name);
 };

 const toggleItem = (item, meal) => {
 setSelected(prev => {
 if(prev[item.id]) {
 const n = {...prev};
 delete n[item.id];
 return n;
 }
 return {...prev, [item.id]: {item, qty: paxCount, meal, instructions:''}};
 });
 };

 const updateQty = (id, qty) => setSelected(prev => ({...prev, [id]: {...prev[id], qty: Math.max(1, qty)}}));
 const updateItemNote = (id, note) => setSelected(prev => ({...prev, [id]: {...prev[id], instructions: note}}));

 const totalItems = Object.keys(selected).length;
 const totalCost = Object.values(selected).reduce((s,s2)=>s+(s2.item.price*s2.qty),0);

 const mealData = MENU_DATA[activeMeal];
 const allItems = Object.entries(mealData.categories).flatMap(([cat,items])=>items.map(i=>({...i,cat})));
 const filtered = allItems.filter(i =>
 (filterVeg==='All' || (filterVeg==='Veg'?i.veg:!i.veg)) &&
 (search===''||i.name.toLowerCase().includes(search.toLowerCase())||i.cat.toLowerCase().includes(search.toLowerCase()))
 );

 const handleSave = () => {
 const order = {
 bookingId: booking?.id || 'BTX-NEW',
 bookingRef: booking?.ref || 'New Booking',
 pax: paxCount,
 createdAt: new Date().toISOString(),
 specialInstructions: instructions,
 items: Object.values(selected),
 totalCost,
 status: 'Pending Kitchen Confirmation',
 };
 onSave(order);
 };

 return (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',zIndex:200,display:'flex',alignItems:'flex-start',justifyContent:'center',padding:16,overflowY:'auto'}}>
 <div style={{width:'100%',maxWidth:1100,background:C.bg,borderRadius:16,overflow:'hidden',boxShadow:'0 24px 64px rgba(0,0,0,.2)'}}>

 {/* Header */}
 <div style={{background:`linear-gradient(135deg,${C.dark},#1A3A22)`,padding:'18px 24px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
 <div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:'#fff'}}> Food Menu Selector</div>
 <div style={{fontSize:12,color:'rgba(255,255,255,.5)',marginTop:2}}>
 Booking: {booking?.ref||'New'} · 
 <input type="number" value={paxCount} onChange={e=>setPaxCount(parseInt(e.target.value)||1)}
 style={{width:50,margin:'0 4px',padding:'2px 6px',borderRadius:5,border:'none',background:'rgba(255,255,255,.15)',color:'#fff',fontSize:12,textAlign:'center'}}/>
 pax
 </div>
 </div>
 <div style={{display:'flex',gap:10,alignItems:'center'}}>
 <div style={{padding:'8px 16px',background:'rgba(58,175,88,.2)',borderRadius:9,border:'1px solid rgba(58,175,88,.4)'}}>
 <span style={{fontSize:13,fontWeight:700,color:C.accent}}>{totalItems} items · {inr(totalCost)}</span>
 </div>
 <button onClick={onClose} style={{width:32,height:32,borderRadius:8,border:'1px solid rgba(255,255,255,.2)',background:'rgba(255,255,255,.1)',color:'#fff',cursor:'pointer',fontSize:16}}></button>
 </div>
 </div>

 {/* Package presets */}
 <div style={{padding:'12px 20px',background:'#1A3A22',borderBottom:`1px solid rgba(255,255,255,.1)`,display:'flex',gap:8,overflowX:'auto'}}>
 <span style={{fontSize:11,color:'rgba(255,255,255,.4)',alignSelf:'center',whiteSpace:'nowrap',marginRight:4}}>Quick Packages:</span>
 {PACKAGE_PRESETS.map(p=>(
 <button key={p.name} onClick={()=>applyPreset(p)}
 style={{padding:'6px 14px',borderRadius:99,border:`1px solid ${activePreset===p.name?C.accent:'rgba(255,255,255,.2)'}`,background:activePreset===p.name?C.accentLight:'rgba(255,255,255,.05)',color:activePreset===p.name?C.accent:'rgba(255,255,255,.7)',fontSize:11,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>
 {p.name}
 </button>
 ))}
 </div>

 <div style={{display:'grid',gridTemplateColumns:'1fr 320px',minHeight:600}}>
 {/* Left — Menu */}
 <div style={{padding:20,borderRight:`1px solid ${C.border}`}}>

 {/* Meal tabs */}
 <div style={{display:'flex',gap:6,marginBottom:16,flexWrap:'wrap'}}>
 {Object.entries(MENU_DATA).map(([meal,data])=>(
 <button key={meal} onClick={()=>setActiveMeal(meal)}
 style={{padding:'8px 16px',borderRadius:99,border:`1.5px solid ${activeMeal===meal?data.color:C.border2}`,background:activeMeal===meal?data.color+'18':'transparent',color:activeMeal===meal?data.color:C.text3,fontSize:13,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:5}}>
 {data.icon} {meal}
 {Object.values(selected).filter(s=>s.meal===meal).length>0&&
 <span style={{background:data.color,color:'#fff',borderRadius:99,fontSize:10,fontWeight:700,padding:'1px 6px'}}>
 {Object.values(selected).filter(s=>s.meal===meal).length}
 </span>}
 </button>
 ))}
 </div>

 {/* Search & filter */}
 <div style={{display:'flex',gap:8,marginBottom:16}}>
 <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search items..."
 style={{flex:1,padding:'8px 14px',background:C.surface,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}/>
 {['All','Veg','NonVeg'].map(f=>(
 <button key={f} onClick={()=>setFilterVeg(f)}
 style={{padding:'7px 14px',borderRadius:9,border:`1px solid ${filterVeg===f?(f==='Veg'?C.accent:f==='NonVeg'?C.red:C.blue):C.border2}`,background:filterVeg===f?(f==='Veg'?C.accentLight:f==='NonVeg'?C.redBg:C.blueBg):'transparent',color:filterVeg===f?(f==='Veg'?C.accent:f==='NonVeg'?C.red:C.blue):C.text3,fontSize:12,fontWeight:600,cursor:'pointer'}}>
 {f==='NonVeg'?' Non-Veg':f==='Veg'?' Veg':'All'}
 </button>
 ))}
 </div>

 {/* Items by category */}
 {Object.entries(mealData.categories).map(([cat,items])=>{
 const catFiltered = items.filter(i=>
 (filterVeg==='All'||(filterVeg==='Veg'?i.veg:!i.veg))&&
 (search===''||i.name.toLowerCase().includes(search.toLowerCase())||cat.toLowerCase().includes(search.toLowerCase()))
 );
 if(catFiltered.length===0) return null;
 return (
 <div key={cat} style={{marginBottom:16}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:8,paddingBottom:6,borderBottom:`1px solid ${C.border}`}}>{cat}</div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
 {catFiltered.map(item=>{
 const isSelected = !!selected[item.id];
 return (
 <div key={item.id} onClick={()=>toggleItem(item, activeMeal)}
 style={{padding:'10px 12px',borderRadius:10,border:`1.5px solid ${isSelected?mealData.color:C.border}`,background:isSelected?mealData.color+'10':C.surface,cursor:'pointer',transition:'all .15s'}}>
 <div style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:4}}>
 <VegBadge veg={item.veg}/>
 <div style={{flex:1}}>
 <div style={{fontSize:13,fontWeight:isSelected?700:500,color:C.text,lineHeight:1.3}}>{item.name}</div>
 {item.description&&<div style={{fontSize:10,color:C.text3,marginTop:2}}>{item.description}</div>}
 </div>
 <div style={{fontSize:13,fontWeight:700,color:isSelected?mealData.color:C.text2,flexShrink:0}}>{inr(item.price)}</div>
 </div>
 <div style={{fontSize:10,color:C.text3}}>{item.unit}</div>
 {isSelected&&(
 <div style={{marginTop:8,display:'flex',alignItems:'center',gap:6}} onClick={e=>e.stopPropagation()}>
 <button onClick={()=>updateQty(item.id,selected[item.id].qty-10)} style={{width:24,height:24,borderRadius:6,border:`1px solid ${C.border2}`,background:C.bg,cursor:'pointer',fontSize:14,display:'flex',alignItems:'center',justifyContent:'center'}}>-</button>
 <input type="number" value={selected[item.id].qty} onChange={e=>updateQty(item.id,parseInt(e.target.value)||1)}
 style={{width:55,textAlign:'center',padding:'3px 6px',borderRadius:6,border:`1px solid ${C.border2}`,fontSize:12,fontWeight:600,color:C.text}}/>
 <button onClick={()=>updateQty(item.id,selected[item.id].qty+10)} style={{width:24,height:24,borderRadius:6,border:`1px solid ${C.border2}`,background:C.bg,cursor:'pointer',fontSize:14,display:'flex',alignItems:'center',justifyContent:'center'}}>+</button>
 <span style={{fontSize:10,color:C.text3}}>pax</span>
 <span style={{fontSize:11,fontWeight:700,color:mealData.color,marginLeft:'auto'}}>{inr(item.price*selected[item.id].qty)}</span>
 </div>
 )}
 </div>
 );
 })}
 </div>
 </div>
 );
 })}
 </div>

 {/* Right — Order Summary */}
 <div style={{padding:16,background:C.bg,display:'flex',flexDirection:'column',gap:12}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text}}> Order Summary</div>

 {totalItems===0
 ? <div style={{textAlign:'center',padding:'40px 20px',color:C.text3}}>
 <div style={{fontSize:32,marginBottom:8}}></div>
 <div style={{fontSize:13}}>No items selected yet</div>
 <div style={{fontSize:11,marginTop:4}}>Click items from the menu to add</div>
 </div>
 : <div style={{flex:1,overflowY:'auto',display:'flex',flexDirection:'column',gap:6}}>
 {Object.values(selected).map(({item,qty,meal})=>(
 <div key={item.id} style={{padding:'8px 12px',background:C.surface,borderRadius:9,border:`1px solid ${C.border}`}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8}}>
 <div style={{flex:1}}>
 <div style={{display:'flex',alignItems:'center',gap:5}}>
 <VegBadge veg={item.veg}/>
 <span style={{fontSize:12,fontWeight:600,color:C.text}}>{item.name}</span>
 </div>
 <div style={{fontSize:10,color:C.text3,marginTop:2}}>{meal} · {qty} pax · {inr(item.price)}/{item.unit}</div>
 </div>
 <div style={{textAlign:'right',flexShrink:0}}>
 <div style={{fontSize:13,fontWeight:700,color:C.accent}}>{inr(item.price*qty)}</div>
 <button onClick={()=>toggleItem(item,meal)} style={{fontSize:10,color:C.red,background:'none',border:'none',cursor:'pointer',padding:0}}>Remove</button>
 </div>
 </div>
 </div>
 ))}
 </div>
 }

 {/* Special instructions */}
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>Special Instructions</div>
 <textarea value={instructions} onChange={e=>setInstructions(e.target.value)} rows={3}
 placeholder="Allergies, jain food, no onion-garlic, extra spicy, etc..."
 style={{width:'100%',padding:'9px 12px',background:C.surface,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:12,fontFamily:'Inter,sans-serif',resize:'none',boxSizing:'border-box'}}/>
 </div>

 {/* Total */}
 {totalItems>0&&(
 <div style={{padding:'12px 16px',background:C.surface,borderRadius:10,border:`1px solid ${C.border}`}}>
 <div style={{display:'flex',justifyContent:'space-between',fontSize:12,color:C.text3,marginBottom:4}}>
 <span>{totalItems} items · {paxCount} pax</span>
 <span>Per head: {inr(Math.round(totalCost/paxCount))}</span>
 </div>
 <div style={{display:'flex',justifyContent:'space-between',fontSize:16,fontWeight:800,color:C.text}}>
 <span>Total Food Cost</span>
 <span style={{color:C.accent}}>{inr(totalCost)}</span>
 </div>
 </div>
 )}

 <div style={{display:'flex',flexDirection:'column',gap:8}}>
 <Btn onClick={handleSave} disabled={totalItems===0} style={{width:'100%',justifyContent:'center'}}>
 Confirm & Send to Kitchen
 </Btn>
 <Btn variant="ghost" onClick={onClose} style={{width:'100%',justifyContent:'center'}}>
 Cancel
 </Btn>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
}


// ── KITCHEN ORDER CARD ────────────────────────────────────────────────────────
export function KitchenOrderCard({order, onUpdateStatus}) {
 const [expanded, setExpanded] = useState(false);
 const statusColors = {
 'Pending Kitchen Confirmation': {color:C.amber, bg:C.amberBg},
 'Confirmed by Kitchen': {color:C.blue, bg:C.blueBg},
 'Preparation Started': {color:C.purple, bg:C.purpleBg},
 'Ready to Serve': {color:C.accent, bg:C.accentLight},
 'Served': {color:C.text3, bg:C.border},
 };
 const sc = statusColors[order.status] || statusColors['Pending Kitchen Confirmation'];
 const mealGroups = {};
 order.items.forEach(({item,qty,meal})=>{
 if(!mealGroups[meal]) mealGroups[meal] = [];
 mealGroups[meal].push({item,qty});
 });

 return (
 <Card>
 <div style={{padding:'14px 18px',display:'flex',alignItems:'center',gap:12,cursor:'pointer'}} onClick={()=>setExpanded(!expanded)}>
 <div style={{width:44,height:44,borderRadius:11,background:sc.bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}></div>
 <div style={{flex:1}}>
 <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3}}>
 <span style={{fontWeight:700,fontSize:14,color:C.blue}}>{order.bookingRef}</span>
 <span style={{padding:'2px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:sc.color,background:sc.bg}}>{order.status}</span>
 </div>
 <div style={{fontSize:12,color:C.text3}}>{order.pax} pax · {order.items.length} items · {inr(order.totalCost)} · {new Date(order.createdAt).toLocaleDateString('en-IN')}</div>
 {order.specialInstructions&&<div style={{fontSize:11,color:C.amber,marginTop:2}}> {order.specialInstructions}</div>}
 </div>
 <div style={{display:'flex',gap:6,flexDirection:'column',alignItems:'flex-end'}}>
 <span style={{fontSize:11,color:C.text3}}>{expanded?' Hide':' Show'}</span>
 </div>
 </div>

 {expanded&&(
 <div style={{borderTop:`1px solid ${C.border}`,padding:'14px 18px'}}>
 {/* Status actions */}
 <div style={{display:'flex',gap:8,marginBottom:14,flexWrap:'wrap'}}>
 {['Confirmed by Kitchen','Preparation Started','Ready to Serve','Served'].map(s=>(
 <button key={s} onClick={()=>onUpdateStatus(order.bookingId, s)}
 style={{padding:'6px 12px',borderRadius:8,border:`1px solid ${order.status===s?statusColors[s].color:C.border2}`,background:order.status===s?statusColors[s].bg:'transparent',color:order.status===s?statusColors[s].color:C.text3,fontSize:11,fontWeight:600,cursor:'pointer'}}>
 {s}
 </button>
 ))}
 </div>

 {/* Items by meal */}
 {Object.entries(mealGroups).map(([meal,items])=>(
 <div key={meal} style={{marginBottom:12}}>
 <div style={{fontSize:12,fontWeight:700,color:C.text2,marginBottom:6,display:'flex',alignItems:'center',gap:5}}>
 {MENU_DATA[meal]?.icon} {meal}
 </div>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr style={{background:'#F5F8F5'}}>
 {['Item','Veg/NV','Qty','Rate','Total'].map(h=>(
 <th key={h} style={{padding:'6px 10px',fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',textAlign:'left',borderBottom:`1px solid ${C.border}`}}>{h}</th>
 ))}
 </tr></thead>
 <tbody>
 {items.map(({item,qty})=>(
 <tr key={item.id} style={{borderBottom:`1px solid ${C.border}`}}>
 <td style={{padding:'8px 10px',fontSize:13,fontWeight:500}}>{item.name}</td>
 <td style={{padding:'8px 10px'}}><VegBadge veg={item.veg}/></td>
 <td style={{padding:'8px 10px',fontWeight:700,color:C.blue}}>{qty}</td>
 <td style={{padding:'8px 10px',color:C.text3}}>{inr(item.price)}</td>
 <td style={{padding:'8px 10px',fontWeight:700,color:C.accent}}>{inr(item.price*qty)}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 ))}

 {order.specialInstructions&&(
 <div style={{padding:'10px 14px',background:C.amberBg,borderRadius:8,border:`1px solid ${C.amberBorder}`,fontSize:12,color:C.amber}}>
 <strong> Special Instructions:</strong> {order.specialInstructions}
 </div>
 )}
 </div>
 )}
 </Card>
 );
}

// ── MAIN FOOD MENU MODULE ─────────────────────────────────────────────────────
const TABS = [
 {id:'orders', label:'Kitchen Orders', },
 {id:'menu', label:'Full Menu', },
 {id:'new', label:'New Food Order', },
];

// Shared state — in real app this would be in context/backend
export let KITCHEN_ORDERS = [
 {
 bookingId:'BTX-1044', bookingRef:'BTX-1044 — ABC Technologies',
 pax:250, createdAt:'2026-07-03T09:00:00', totalCost:285000,
 specialInstructions:'No onion no garlic for 30 Jain guests',
 status:'Preparation Started',
 items:[
 {item:{id:'l1',name:'Dal Makhani',veg:true,price:160,unit:'per portion'},qty:250,meal:'Lunch'},
 {item:{id:'l3',name:'Paneer Butter Masala',veg:true,price:220,unit:'per portion'},qty:250,meal:'Lunch'},
 {item:{id:'l13',name:'Butter Chicken',veg:false,price:280,unit:'per portion'},qty:200,meal:'Lunch'},
 {item:{id:'l21',name:'Tandoori Roti',veg:true,price:20,unit:'per piece'},qty:500,meal:'Lunch'},
 {item:{id:'l28',name:'Steamed Rice',veg:true,price:80,unit:'per portion'},qty:250,meal:'Lunch'},
 {item:{id:'l35',name:'Veg Fried Rice',veg:true,price:160,unit:'per portion'},qty:100,meal:'Lunch'},
 {item:{id:'h1',name:'Samosa (2 pcs)',veg:true,price:60,unit:'per plate'},qty:250,meal:'Hi-Tea / Snacks'},
 {item:{id:'h11',name:'Chicken Tikka (6 pcs)',veg:false,price:280,unit:'per plate'},qty:150,meal:'Hi-Tea / Snacks'},
 ],
 },
 {
 bookingId:'BTX-1055', bookingRef:'BTX-1055 — Green Valley School',
 pax:180, createdAt:'2026-07-03T10:00:00', totalCost:95400,
 specialInstructions:'Pure veg only. Less spicy.',
 status:'Ready to Serve',
 items:[
 {item:{id:'l1',name:'Dal Makhani',veg:true,price:160,unit:'per portion'},qty:180,meal:'Lunch'},
 {item:{id:'l3',name:'Paneer Butter Masala',veg:true,price:220,unit:'per portion'},qty:180,meal:'Lunch'},
 {item:{id:'l21',name:'Tandoori Roti',veg:true,price:20,unit:'per piece'},qty:360,meal:'Lunch'},
 {item:{id:'l28',name:'Steamed Rice',veg:true,price:80,unit:'per portion'},qty:180,meal:'Lunch'},
 {item:{id:'h1',name:'Samosa (2 pcs)',veg:true,price:60,unit:'per plate'},qty:180,meal:'Hi-Tea / Snacks'},
 {item:{id:'h17',name:'Tea',veg:true,price:30,unit:'per cup'},qty:180,meal:'Hi-Tea / Snacks'},
 ],
 },
];

export default function FoodMenu() {
 const [tab, setTab] = useState('orders');
 const [orders, setOrders] = useState(KITCHEN_ORDERS);
 const [showSelector, setShowSelector] = useState(false);
 const [filterStatus, setFilterStatus] = useState('All');
 const [activeCat, setActiveCat] = useState(null);

 const updateStatus = (bookingId, status) => {
 setOrders(p=>p.map(o=>o.bookingId===bookingId?{...o,status}:o));
 };

 const addOrder = (order) => {
 setOrders(p=>[order,...p]);
 KITCHEN_ORDERS = [order, ...KITCHEN_ORDERS];
 setTab('orders');
 };

 const filteredOrders = orders.filter(o=>filterStatus==='All'||o.status===filterStatus);

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text}}>
 {showSelector&&<FoodMenuSelector booking={{id:'BTX-NEW',ref:'New Order'}} pax={100} onSave={order=>{addOrder(order);setShowSelector(false);}} onClose={()=>setShowSelector(false)}/>}

 {/* Header */}
 <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:'0 28px',position:'sticky',top:0,zIndex:50}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',height:62}}>
 <div>
 <div style={{fontSize:11,color:C.text3,fontWeight:500,marginBottom:1}}>F&B Management</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.text}}>Food Menu & Kitchen Orders</div>
 </div>
 <div style={{display:'flex',gap:10}}>
 <div style={{padding:'7px 14px',background:C.amberBg,borderRadius:9}}>
 <span style={{fontSize:12,fontWeight:700,color:C.amber}}>{orders.filter(o=>o.status==='Pending Kitchen Confirmation').length} Pending Confirmation</span>
 </div>
 <Btn onClick={()=>setShowSelector(true)}> New Food Order</Btn>
 </div>
 </div>
 <div style={{display:'flex',gap:0}}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{padding:'10px 18px',background:'transparent',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===t.id?C.accent:C.text3,borderBottom:`2px solid ${tab===t.id?C.accent:'transparent'}`,display:'flex',alignItems:'center',gap:5}}>
 {t.icon} {t.label}
 </button>
 ))}
 </div>
 </div>

 <div style={{padding:'24px 28px'}}>

 {/* KITCHEN ORDERS */}
 {tab==='orders'&&(
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12,marginBottom:20}}>
 {[['Pending',orders.filter(o=>o.status==='Pending Kitchen Confirmation').length,C.amber,C.amberBg],
 ['Confirmed',orders.filter(o=>o.status==='Confirmed by Kitchen').length,C.blue,C.blueBg],
 ['In Preparation',orders.filter(o=>o.status==='Preparation Started').length,C.purple,C.purpleBg],
 ['Ready',orders.filter(o=>o.status==='Ready to Serve').length,C.accent,C.accentLight],
 ['Served',orders.filter(o=>o.status==='Served').length,C.text3,C.border],
 ].map(([l,v,c,bg])=>(
 <div key={l} style={{padding:'14px 16px',background:C.surface,borderRadius:12,border:`1px solid ${C.border}`,cursor:'pointer'}} onClick={()=>setFilterStatus(filterStatus===l?'All':l)}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:6}}>{l}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:24,fontWeight:800,color:c}}>{v}</div>
 </div>
 ))}
 </div>

 <div style={{display:'flex',flexDirection:'column',gap:12}}>
 {filteredOrders.map(order=>(
 <KitchenOrderCard key={order.bookingId} order={order} onUpdateStatus={updateStatus}/>
 ))}
 {filteredOrders.length===0&&(
 <div style={{textAlign:'center',padding:'48px',color:C.text3}}>
 <div style={{fontSize:48,marginBottom:12}}></div>
 <div style={{fontSize:16,fontWeight:700}}>No orders found</div>
 </div>
 )}
 </div>
 </div>
 )}

 {/* FULL MENU VIEW */}
 {tab==='menu'&&(
 <div>
 <div style={{display:'flex',gap:8,marginBottom:20,flexWrap:'wrap'}}>
 {Object.entries(MENU_DATA).map(([meal,data])=>(
 <button key={meal} onClick={()=>setActiveCat(activeCat===meal?null:meal)}
 style={{padding:'8px 18px',borderRadius:99,border:`1.5px solid ${activeCat===meal?data.color:C.border2}`,background:activeCat===meal?data.color+'18':'transparent',color:activeCat===meal?data.color:C.text3,fontSize:13,fontWeight:600,cursor:'pointer'}}>
 {data.icon} {meal}
 </button>
 ))}
 </div>
 {Object.entries(MENU_DATA).filter(([meal])=>!activeCat||activeCat===meal).map(([meal,data])=>(
 <div key={meal} style={{marginBottom:24}}>
 <div style={{fontSize:16,fontWeight:800,color:data.color,marginBottom:12,display:'flex',alignItems:'center',gap:8}}>{data.icon} {meal}</div>
 {Object.entries(data.categories).map(([cat,items])=>(
 <div key={cat} style={{marginBottom:16}}>
 <div style={{fontSize:12,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:8}}>{cat}</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8}}>
 {items.map(item=>(
 <div key={item.id} style={{padding:'10px 12px',background:C.surface,borderRadius:9,border:`1px solid ${C.border}`}}>
 <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:4}}>
 <VegBadge veg={item.veg}/>
 <span style={{fontSize:12,fontWeight:600,color:C.text,flex:1}}>{item.name}</span>
 <span style={{fontSize:12,fontWeight:700,color:C.accent}}>{inr(item.price)}</span>
 </div>
 {item.description&&<div style={{fontSize:10,color:C.text3}}>{item.description}</div>}
 <div style={{fontSize:10,color:C.text3,marginTop:2}}>{item.unit}</div>
 </div>
 ))}
 </div>
 </div>
 ))}
 </div>
 ))}
 </div>
 )}

 {/* NEW ORDER */}
 {tab==='new'&&(
 <div style={{textAlign:'center',padding:'48px'}}>
 <div style={{fontSize:48,marginBottom:16}}></div>
 <div style={{fontSize:20,fontWeight:700,color:C.text,marginBottom:8}}>Create New Food Order</div>
 <div style={{fontSize:14,color:C.text3,marginBottom:24}}>Select items from the full menu and send directly to kitchen</div>
 <Btn onClick={()=>setShowSelector(true)} style={{fontSize:15,padding:'12px 32px'}}>Open Food Menu Selector</Btn>
 </div>
 )}
 </div>
 </div>
 );
}
